/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react
import React from "react";
// BASE Components
import BASESvgIcon from "../../../../../@BASE/core/BASESvgIcon";
// Material-UI Components
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Item from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const PageSubheader = (props) => {
  const { data } = props;

  return (
    <div>
      <Grid container spacing={2} className="w-full">
        {data.map((item, index) => (
          <Grid item key={index} xs={3}>
            <Item>
              <Typography className="text-md font-semibold leading-5">
                {item.resource} {item.label}
              </Typography>
              <Typography className="mt-2 text-md line-clamp-2 text-secondary">
                {item.value}
              </Typography>
            </Item>
          </Grid>
        ))}
      </Grid>
      {/* <Breadcrumbs
        separator={<BASESvgIcon size={20}>heroicons-solid:chevron-right</BASESvgIcon>}
        aria-label="breadcrumb"
      >
        {data.map((item, index) => (            
          <Link
            key={index}
            underline="hover"
            color="textWhite"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#ffffff !important",
            }}
            href={item.path}
          >
            <BASESvgIcon size={20}>{item.icon}</BASESvgIcon>
            <span className="text-sm font-bold ml-4 mr-2">{item.label}:</span>
            <span className="text-sm">{item.value}</span>
          </Link>
        ))}
      </Breadcrumbs> */}
    </div>
  );
};

export default PageSubheader;
